<template>
  <form id="login-form" class="form" @submit.prevent="handleSubmit">
    <div class="log_main">
      <div class="bindPhine_title">
        <p>请输入帐号</p>
      </div>
      <div class="log_ui logTool">
        <div class="dsib log_tool_outer vm">
          <input
            class="txt username vm"
            type="text"
            id="userNameInp"
            placeholder="输入帐号"
            :value="account"
            @input="updateStore('account', $event.target.value)"
            tabindex="1"
          />
        </div>
      </div>
      <div class="append_op dsib">
        <div class="dsib autoLogSet" id="err">{{ errmsg }}</div>
      </div>
      <div class="logBtnOuter btn-find-pwd">
        <BtnWithLoading type="submit" class="btn">下一步</BtnWithLoading>
      </div>
    </div>
  </form>
</template>
<script>
import { mapState, updateStore, handleErr } from '@/mixins';

export default {
  mixins: [mapState, updateStore, handleErr],
  methods: {
    handleSubmit() {
      const payload = {
        _csrf: this.csrf,
        challenge: this.challenge,
        LoginType: this.loginType,
      };

      payload.account_name = this.account && this.encrypter.encrypt(this.account);

      this.isPending = true;
      this.$api
        .findpwd(payload)
        .then((res) => {
          this.isPending = false;
          const data = res.data || {};
          if (data.errcode !== '0' && data.errmsg) {
            this.updateStore('errmsg', data.errmsg);
          }

          if (data.errcode === '0') {
            this.updateStore('appId', data.data.AppId);
            this.updateStore('areaCode', data.data.AreaCode);
            this.updateStore('phoneMask', data.data.PhoneMask);
            this.updateStore('phoneCipher', data.data.PhoneCipher);
            this.updateStore('errmsg', '');

            this.$router.push('/verifyphone');
          }
        })
        .catch((err) => {
          this.handleErr(err);
        });
    },
  },
};
</script>
